var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.note?'shadow':'',style:([
  {backgroundColor: _vm.color},
  _vm.image?{backgroundImage: `url(.${_vm.image})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat'}:{},
  _vm.position ? {backgroundPosition: _vm.position} : {},
  _vm.ImgSize ? {backgroundSize: _vm.ImgSize} : {}
]),on:{"click":function($event){return _vm.$emit('push')}}},[_c('div',{staticClass:"colorImage"}),_c('div',[_c('div',{style:([{
      color: _vm.color
    }])},[_vm._v(_vm._s(_vm.name))]),_c('div',[_vm._v(_vm._s(_vm.name_eng))])]),(_vm.note)?_c('div',{staticClass:"note"},[_vm._v(_vm._s(_vm.note))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }